import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';


import {usageReportsStateSelector} from './usage-reports-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {ReportMetadata} from 'src/openapi/admin/models/ReportMetadata';

export const usageReportsSlice = getCachedTableDataSlice<
    ReportMetadata[],
    undefined,
    undefined,
    undefined
>('usageReports');

export const usageReportsActions = usageReportsSlice.actions;
const usageReportsCacheSelector: CachedTableCacheSelector<ReportMetadata[]>
    = state => state.accountPage.tabs.licenseAndFeatures.reports.usageReport.reports.cache;
export const usageReportsDataSelector: CachedTableDataSelector<ReportMetadata[]>
    = state => state.accountPage.tabs.licenseAndFeatures.reports.usageReport.reports;
export const usageReportsResultSelector = getCachedTableResultSelector(
    usageReportsCacheSelector,
    usageReportsStateSelector,
);
